import React, { useState } from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import CustomText from "pages/_components/CustomText/CustomText";
import Drawer from "pages/_components/Drawer/Drawer";
import * as i18n from "util/i18n";

const TitleColumns = () => {
    const [showVoucherInfo, setShowVoucherInfo] = useState(false);

    const VoucherInfo = () => (
        <Drawer className="help-slider" openSidebar={showVoucherInfo} toggleSidebar={() => setShowVoucherInfo(false)}>
            <div className="container payway-terminal-type-help-container">
                <div
                    className="row"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: i18n.get("comex.voucher.info.content"),
                    }}
                />
            </div>
        </Drawer>
    );
    return (
        <>
            <VoucherInfo />
            <GridTable.Data columnStart={1} rowStart={1} rowWidth={1} alignY="center" alignX="center">
                <I18n component="span" id="comexTransaction.table.beneficiary" />
            </GridTable.Data>
            <GridTable.Data columnStart={2} rowStart={1} rowWidth={1} alignY="center" alignX="center">
                <I18n component="span" id="comexTransaction.table.amount" />
            </GridTable.Data>
            <GridTable.Data columnStart={3} rowStart={1} rowWidth={1} alignY="center" alignX="center">
                <I18n component="span" id="comexTransaction.table.creationDate" />
            </GridTable.Data>
            <GridTable.Data columnStart={4} rowStart={1} rowWidth={1} alignY="center" alignX="center">
                <CustomText
                    text="comexTransaction.table.idTransaction"
                    textType="I18N"
                    showTooltip
                    onTooltipClick={() => setShowVoucherInfo(true)}
                />
            </GridTable.Data>
            <GridTable.Data columnStart={5} rowStart={1} rowWidth={1} alignY="center" alignX="center">
                <I18n component="span" id="comexTransaction.table.status" />
            </GridTable.Data>
            <GridTable.Data columnStart={6} rowStart={1} rowWidth={1} alignY="center" alignX="center" />
        </>
    );
};

export default TitleColumns;
